// extracted by mini-css-extract-plugin
export var centerText = "_ev-8";
export var container = "_ev-0";
export var doughnutContainer = "_ev-7";
export var legend = "_ev-a";
export var legendItemColorDisplay = "_ev-b";
export var legendItemLabel = "_ev-d";
export var legendItemValue = "_ev-c";
export var lg = "_ev-5";
export var maxWidth = "_ev-9";
export var md = "_ev-4";
export var responsive = "_ev-6";
export var sm = "_ev-3";
export var xs = "_ev-2";
export var xxs = "_ev-1";